import type { CSSProperties, ReactNode } from "react";

type RuntimeGridAttributes = { style: CSSProperties };

interface RuntimeGridRowsProps {
  template: string;
  children: (attributes: RuntimeGridAttributes) => ReactNode;
}

interface RuntimeGridColumnsProps {
  template: string;
  children: (attributes: RuntimeGridAttributes) => ReactNode;
}

interface RuntimeGridAreaProps {
  area: string;
  children: (attributes: RuntimeGridAttributes) => ReactNode;
}

/** Applies grid rows calculated from live scheduling intervals. */
export function RuntimeGridRows({ template, children }: RuntimeGridRowsProps): ReactNode {
  return children({ style: { gridTemplateRows: template } });
}

/** Applies grid columns calculated from a runtime data shape. */
export function RuntimeGridColumns({ template, children }: RuntimeGridColumnsProps): ReactNode {
  return children({ style: { gridTemplateColumns: template } });
}

/** Places an item in a grid area calculated from live dates and times. */
export function RuntimeGridArea({ area, children }: RuntimeGridAreaProps): ReactNode {
  return children({ style: { gridArea: area } });
}
